// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLoginInput_root__lxxx0","rootdanger":"PlasmicLoginInput_rootdanger__cyHgz"};